export default __webpack_public_path__ + "static/media/Intimation of trading window closure.2f91727e.pdf";